import { Card, CardContent, Typography, CircularProgress, Box } from "@mui/material";
import StatDescriptionTooltip from "./StatDescriptionTooltip";

export default function StatCard({ icon: Icon, value, label, description, error, iconColor = "primary.main" }) {
  return (
    <Card sx={{ minWidth: 250, flex: 1 }}>
      <CardContent sx={{ textAlign: "center" }}>
        {Icon && <Icon sx={{ fontSize: 48, color: iconColor, mb: 1 }} />}
        {error ? (
          <Typography color="error" variant="body2">
            Error: {error}
          </Typography>
        ) : (
          <Typography variant="h4" fontWeight="bold">
            {value !== null ? value : <CircularProgress size={32} />}
          </Typography>
        )}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }}>
          <Typography variant="body1" color="text.secondary">
            {label}
          </Typography>
          <StatDescriptionTooltip description={description} fontSize={16} />
        </Box>
      </CardContent>
    </Card>
  );
}
